var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutstanding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.41 27.741 27.874 3.271A4.393 4.393 0 0 0 24 1a4.417 4.417 0 0 0-3.874 2.249L5.57 27.763a4.436 4.436 0 0 0 .044 4.431 4.403 4.403 0 0 0 3.83 2.205h29.113c1.58 0 3.028-.824 3.83-2.205.801-1.38.823-3.028.022-4.453z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.387 32.194a4.403 4.403 0 0 1-3.83 2.204H24V1c1.625 0 3.073.846 3.874 2.271l14.536 24.47c.801 1.425.78 3.073-.023 4.453z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4A696F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.773 24.379h4.453v4.453h-4.453zM21.773 11.02h4.453v11.133h-4.453z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3E5959"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 11.02h2.227v11.133H24zM24 24.379h2.227v4.453H24z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutstanding);
export default __webpack_public_path__ + "static/media/outstanding.64eab6d26acadd3f47ad181993c69d38.svg";
export { ForwardRef as ReactComponent };